export const SET_LINK_PREVIEW_LOADING_START = 'SET_LINK_PREVIEW_LOADING_START';
export const GET_LINK_PREVIEW_RESULTS_SUCCESS = 'GET_LINK_PREVIEW_RESULTS_SUCCESS';
export const GET_LINK_PREVIEW_RESULTS_FAILURE = 'GET_LINK_PREVIEW_RESULTS_FAILURE';

export const setLinkPreviewLoading = ({ formKey, id }) => ({
  type: SET_LINK_PREVIEW_LOADING_START,
  payload: {
    formKey,
    id,
  },
});

export const getLinkPreviewResultsSuccess = ({ formKey, id, formData, entityData }) => ({
  type: GET_LINK_PREVIEW_RESULTS_SUCCESS,
  payload: {
    formKey,
    id,
    formData,
    entityData,
  },
});

export const getLinkPreviewResultsFailure = ({ formKey, id, errors }) => ({
  type: GET_LINK_PREVIEW_RESULTS_FAILURE,
  payload: {
    formKey,
    id,
    errors,
  },
});
